import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Typed from "typed.js";
import Globe from "../Components/SoftBox/globe.js";
import DesignRush from "../../assets/img/DesignRush.png";

const HomeVideo = ({ title, description, typeStrings }) => {
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: typeStrings,
      startDelay: 300,
      typeSpeed: 100,
      backSpeed: 50,
      backDelay: 800,
      loop: true,
    });

    return () => typed.destroy();
  }, [typeStrings]);

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobileXLOrSmaller = screenSize <= 600;

  return (
    <div className={`home-video-container ${isMobileXLOrSmaller ? "pt-24" : ""} h-screen flex flex-col md:flex-row items-center justify-center`}>
      <div className="w-full md:w-1/2 flex flex-col items-center p-8 md:items-start justify-center  z-10 text-center md:text-left">
        <div>
          <h1
            className={`text-${isMobileXLOrSmaller ? "3xl" : "5xl"} font-bold leading-tight mb-2 text-bluegray`}
          >
            {title}
          </h1>
          <p className={`text-${isMobileXLOrSmaller ? "xl" : "2xl"} text-bluegray opacity-80 mb-6`}>
            {description}
          </p>
          <p className={`text-${isMobileXLOrSmaller ? "2xl" : "4xl"}`}>
            <span ref={el} className="text-lightBlue-500 ml-2" />
          </p>
          <div className={`flex justify-${isMobileXLOrSmaller ? "center" : "start"}  mt-20`}>
            <a href="https://www.designrush.com/agency/profile/svegile-technologies-private-limited" target="_blank" rel="noopener noreferrer">
              <img
                src={DesignRush}
                alt="Svegile Technologies on DesignRush"
                className="max-w-full"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="w-full md:w-1/2 flex items-center justify-center p-8 relative -Z-10">
        <div className="relative w-full h-full flex items-center justify-center">
          <Globe
            display={{ xs: "block", md: "block" }}
            canvasStyle={{
              width: "100%",
              height: "100%",
              maxWidth: "none",
              maxHeight: "none",
            }}
            className="md:max-w-none md:max-h-none"
          />
        </div>
      </div>
    </div>
  );
};

HomeVideo.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  typeStrings: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default HomeVideo;
